import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { LeaderboardEntry } from '../types/ranking';

export function useLeaderboard(type: string) {
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .rpc('get_animatronic_rankings', {
            ranking_type: type
          });

        if (error) throw error;
        setLeaderboard(data || []);
      } catch (err) {
        console.error('Error fetching leaderboard:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch leaderboard'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboard();
  }, [type]);

  return { leaderboard, isLoading, error };
}